module.exports = __webpack_public_path__ + "img/Scenarios_What_is_Scenario_Planning.14998bb1.jpg";